module.exports = __webpack_public_path__ + "static/img/xnhb.346e6efc.png";